import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import { colors } from 'style/config';

const ProductViewsCount = props => {
    const {
        peopleViewing, thresholdForViews, localization, formatViewCount, setAnalytics, lookBackWindowForViews, showSessionAIMsg
    } = props;
    const hasReachedThreshold = peopleViewing && thresholdForViews && peopleViewing >= thresholdForViews;

    if (hasReachedThreshold) {
        setAnalytics(lookBackWindowForViews);
    }

    if (!showSessionAIMsg || !peopleViewing || !thresholdForViews || !hasReachedThreshold) {
        return null;
    }

    return (
        <Box
            marginTop={4}
            backgroundColor={colors.black}
            borderRadius={2}
            paddingLeft={2}
            paddingRight={2}
            width='fit-content'
            maxWidth='375px'
        >
            <Text
                is='p'
                lineHeight='24px'
                fontSize='sm'
                color={colors.white}
            >
                <Text paddingRight={1}>🤩</Text>
                {localization.popularNow} <strong>{formatViewCount(peopleViewing)}+</strong> {localization.peopleViewed}
            </Text>
        </Box>
    );
};

export default wrapFunctionalComponent(ProductViewsCount, 'ProductViewsCount');
